import { ModelInModelTreeInProcessEditor } from "../create-model-tree-for-porcess-editor-and-set-uuid/create-model-tree-for-porcess-editor-and-set-uuid";

export const isAncestorInModelTreeInProcessEditor = (descendantUUID: string, ancestorUUID: string, modelTree: ModelInModelTreeInProcessEditor[]): boolean => {
    // Depth-First Search
    function dfs(node: ModelInModelTreeInProcessEditor, hasAncestor: boolean): boolean {
        if (node.uuid === descendantUUID && hasAncestor) {
            return true;
        }

        for (const child of node.children) {
            if (dfs(child, hasAncestor || node.uuid === ancestorUUID)) {
                return true;
            }
        }

        return false;
    }

    for (const root of modelTree) {
        if (dfs(root, root.uuid === ancestorUUID)) {
            return true;
        }
    }

    return false;
};